<!-- 车皮到达预报 -->
<template>
  <div>
    <el-card style="margin-bottom: 20px;">
      <div class="title">
        <p></p>
        <div>
          <el-select v-model="value1" placeholder="全部客户" style="width: 160px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="value1" placeholder="车次编号" style="width: 160px;margin-left: 20px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="value" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" style="margin-left: 20px;" :picker-options="pickerOptions">
          </el-date-picker>
          <el-button type="primary" icon="el-icon-search" style="margin-left: 16px;width: 98px;">搜索</el-button>
          <el-button icon="el-icon-refresh-left" style="margin-left: 16px;width: 98px;">重置</el-button>
        </div>
      </div>
    </el-card>
    <el-card style="height: 500px;">
      <div class="title" style="margin-bottom: 10px;">
        <!-- <p>明细数据</p> -->
        <el-button type="primary" icon="el-icon-plus">新增计划</el-button>
      </div>
      <avue-crud :data="data" :option="option" :page.sync="page">
        <template slot="menu">
             <el-button type="text">编辑</el-button>
             <el-button type="text">到达详情</el-button>
             <el-button type="text">删除</el-button>
        </template>
      </avue-crud>
    </el-card>
    <div style="height: 80px;"></div>
  </div>
</template>
<script>
import { getDefaultSearchTimeRange, getSearchTimePickerOptions } from '@/basic-common/util/common'

export default {
  name: "store-management/index/index",
  components: {
  },
  data() {
    return {
      page: {
        pageSize: 10, // 每页显示10条
        currentPage: 1, // 第一页
        total: 3 // 总条数
      },
      data: [{
        name1: '北京仓库',
        name2: 'A 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 1,
        name7: 1,
        name8: 1,
        name9: 1,
      }, {
        name1: '北京仓库',
        name2: 'A 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 1,
        name7: 1,
        name8: 1,
        name9: 0,
      }, {
        name1: '北京仓库',
        name2: 'A 区',
        name3: '无烟煤',
        name4: '42,156 吨',
        name5: '15 天',
        name6: 1,
        name7: 1,
        name8: 1,
        name9: 1,
      }],
      option: {
        header: false,
        height: '370px',
        delBtn: false,
        editBtn: false,
        column: [{
          label: '货主',
          prop: 'name1',
          align: 'center'
        }, {
          label: '车次编号',
          prop: 'name2',
          align: 'center'
        }, {
          label: '车厢数',
          prop: 'name3',
          align: 'center'
        }, {
          label: '物资类型',
          prop: 'name4',
          align: 'center'
        }, {
          label: '发货方',
          prop: 'name5',
          align: 'center'
        }, {
          label: '总重量(吨)',
          prop: 'name6',
          align: 'center'
        }, {
          label: '物资信息',
          prop: 'name7',
          align: 'center'
        }, {
          label: '合同信息',
          prop: 'name8',
          align: 'center'
        }, {
          label: '到达时间',
          prop: 'name9',
          align: 'center'
        },{
          label: '发车时间',
          prop: 'name10',
          align: 'center'
        }]
      },
      value: getDefaultSearchTimeRange('daterange'),
      pickerOptions: getSearchTimePickerOptions('daterange'),
      value1: '',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
    };
  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang="scss">
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    color: #000000;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin: 0;
  }
}

::v-deep .el-input__icon {
  line-height: 1 !important;
}
</style>
